import {
  USER_TABLE,
  USER_IS_FETCHING,
  USER_IS_UPDATING,
  USER_PASSWORD_IS_UPDATING,
  USER_SUCCESS,
  USER_GET_ALL,
  USER_LIST_IS_FETCHING,
  USER_DELETE_ID,
  USER_DELETE_ARRAY,
  USER_CREATE,
  USER_UPDATE_ID,
  USER_STATUS_UPDATING
} from '../types'

const initialState = {
  isFetching: true,
  isUpdating: false,
  isPasswordUpdating: false,
  isStatusUpdating: false,
  info: {
    role: null,
    organization: {
      id: 0,
      name: 'Yessspad'
    }
  },
  list: [],
  listFetching: true,
  table: {
    searchString: '',
    searchRoles: [],
    searchGroups: [],
    keys: [],
    rows: []
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case USER_TABLE:
      return {
        ...state,
        table: {
          ...state.table,
          ...action.payload
        }
      }

    case USER_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload
      }

    case USER_LIST_IS_FETCHING:
      return {
        ...state,
        listFetching: action.payload
      }

    case USER_IS_UPDATING:
      return {
        ...state,
        isUpdating: action.payload
      }

    case USER_STATUS_UPDATING:
      return {
        ...state,
        isStatusUpdating: action.payload
      }

    case USER_PASSWORD_IS_UPDATING:
      return {
        ...state,
        isPasswordUpdating: action.payload
      }

    case USER_SUCCESS:
      return {
        ...state,
        info: action.payload
      }

    case USER_GET_ALL:
      return {
        ...state,
        list: action.payload
      }

    case USER_DELETE_ID:
      return {
        ...state,
        list: [
          ...state.list.filter(user => user.id !== action.payload.id)
        ]
      }
    case USER_DELETE_ARRAY:
      return {
        ...state,
        list: [
          ...state.list.filter(x => !action.payload.filter(y => y.id === x.id).length)
        ]
      }

    case USER_CREATE:
      return {
        ...state,
        list: [
          ...state.list,
          action.payload
        ]
      }

    case USER_UPDATE_ID:
      return {
        ...state,
        list: state.list.map(user => user.id === action.payload.id ? action.payload : user)
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/user.js